module.exports = __webpack_public_path__ + "img/CALENDER.f853048c.svg";